export default __webpack_public_path__ + "static/media/icon_business_apps.3ae0ec3b.png";